import { getCheckpointUppyInstance } from './getCheckpointUppyInstance';
import { getCheckpointCompletionStatus } from './getCheckpointCompletionStatus';

/**
 * Performs the following operations:
 * 1. Adds CompletionStatus property to each checkpoint
 * 2. Adds UppyInstance property to each checkpoint if the checkpoint is of type Attachment
 * @param checklists PatrolChecklist[]
 * @returns
 * @author Luqman Bukhari
 */
export const enhanceChecklistData = (checklists: PatrolChecklist[]) => {
	return checklists.map((checklist) => {
		return {
			...checklist,
			Checkpoints: checklist.Checkpoints.map(
				(checkpoint): PatrolCheckpoint => {
					return {
						...checkpoint,
						CompletionStatus:
							getCheckpointCompletionStatus(checkpoint),
						UppyInstance:
							checkpoint.ResponseTypeName === 'Attachment' ||
							checkpoint.ResponseTypeName === 'Signature'
								? getCheckpointUppyInstance(
										checkpoint.CheckpointID,
								  )
								: null,
					};
				},
			),
		};
	});
};
